module.exports = __webpack_public_path__ + "static/media/tools-h5p-2.6c4e2b31.svg";